// extracted by mini-css-extract-plugin
export default {"container":"PublicMain_container_x5qQC","logo":"PublicMain_logo_VwwqM","title":"PublicMain_title_J_VPL"};